"use strict";

require("core-js/modules/esnext.string.replace-all.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var classes_1 = require("../../classes");
// custom message
function numberRange(value, _ref) {
  var _ref$minNumber = _ref.minNumber,
    minNumber = _ref$minNumber === void 0 ? 0 : _ref$minNumber,
    maxNumber = _ref.maxNumber,
    _ref$decimalSymbol = _ref.decimalSymbol,
    decimalSymbol = _ref$decimalSymbol === void 0 ? ',' : _ref$decimalSymbol,
    thousandsSeparatorSymbol = _ref.thousandsSeparatorSymbol,
    abovePermitedValueMessage = _ref.abovePermitedValueMessage,
    underPermitedValueMessage = _ref.underPermitedValueMessage;
  if (!value && typeof value !== 'number') return new classes_1.ValidationResult(true);
  var stringfiedValue = String(value);
  var onlyNumbers = stringfiedValue.replace(/[^0-9,.]/g, '');
  var withoutThousandSeparator = !!thousandsSeparatorSymbol // 1000000
  ? onlyNumbers.replaceAll(thousandsSeparatorSymbol, '') : onlyNumbers;
  var withDecimalPoint = withoutThousandSeparator.replaceAll(decimalSymbol, '.');
  var formatted = Number(withDecimalPoint);
  if ((typeof minNumber === 'number' || typeof minNumber === 'string') && formatted < Number(minNumber)) {
    var message = underPermitedValueMessage || 'O número recebido é menor que o permitido';
    return new classes_1.ValidationResult(false, message);
  }
  if ((typeof maxNumber === 'number' || typeof maxNumber === 'string') && formatted > Number(maxNumber)) {
    var _message = abovePermitedValueMessage || 'O número recebido é maior que o permitido';
    return new classes_1.ValidationResult(false, _message);
  }
  return new classes_1.ValidationResult(true);
}
exports.default = new classes_1.Validator(numberRange);